import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';

import EnhancedTable from './EnhancedTable';
import TasksIssuesFormComponent from './FormComponent';
import TasksIssuesReadOnlyFormComponent from './ReadOnlyFormComponent';
import TimesheetFormComponent from '../Timesheet/FormComponent';
import TimesheetFormComponentTW from '../Timesheet/FormComponentTW';
import ImportCSV from './ImportCSV';
import Progress from '../Common/Progress';
import { userActions, projectActions, tasksissuesActions } from '../../_actions';

const formatter1 = 'YYYY-MM-DD';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit
    },
    tabPaper: {
        flexGrow: 1,
        borderRadius: '5px',
    },
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
});

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            openTimesheetForm: false,
            openReadOnly: false,
            ownerId: this.props.user.id,
            importCsvData: [],
            importCsvOpen: false,
            value: 1,
            openProgress: false
        };
    }

    componentDidMount() {
        this.props.dispatch(userActions.getAll());
        this.props.Pagename === 'Project' ? this.props.dispatch(tasksissuesActions(this.props.ProjectId)) :
            this.props.dispatch(tasksissuesActions.getAllByUserId(this.props.user.id));
        this.props.dispatch(projectActions.getAllByUserId(this.props.user.id));

    }

    handleOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleClose = () => {
        this.setState({
            open: false,
            openTimesheetForm: false,
            openReadOnly: false,
            taskId: '',
            importCsvData: [],
            importCsvOpen: false,
            openProgress: false
        });
    }

    handleEditTable = (EditData) => {
        this.setState({
            open: true,
            taskId: EditData.id,
        });
    }

    handleDeleteTable = (DeleteData) => {
        this.props.dispatch(tasksissuesActions.delete(DeleteData));
    }

    handleCreateTimesheetClick = (CreateTimeSheetData) => {
        this.setState({
            openTimesheetForm: true,
            taskId: CreateTimeSheetData[0]
        })
    }

    handleTabsChange = (event, value) => {
        this.setState({ value });
    };

    handleCsvUpload = (dataArray) => {
        if (dataArray) {

            let jsonArray = [];
            for (let i = 1; i < dataArray.length; i++) {
                if (moment(dataArray[i][5]).format(formatter1) !== 'Invalid date' &&
                    moment(dataArray[i][6]).format(formatter1) !== 'Invalid date' &&
                    !Number.isNaN(Number(dataArray[i][4]))) {
                    let json = {
                        "id": i,
                        "TaskType": dataArray[i][0],
                        "TaskName": dataArray[i][1],
                        "TaskNotes": dataArray[i][2],
                        "AssignedToId": dataArray[i][3],
                        "OwnerId": this.props.user.id,
                        "ProjectId": Number(dataArray[i][4]),
                        "Status": 1,
                        "StartDate": moment(dataArray[i][5]).format(formatter1),
                        "Duration": dataArray[i][6],
                        "EndDate": moment(dataArray[i][7]).format(formatter1),
                        "CreatedUserId": this.props.user.id,
                    }

                    jsonArray.push(json);
                }
            }

            this.setState({
                importCsvOpen: true,
                importCsvData: jsonArray
            });
        }
    }

    handleCsvSaveClick = () => {
        const insertData = async () => {
            try {
                this.setState({
                    openProgress: true
                })
                await this.props.dispatch(tasksissuesActions.insert(this.state.importCsvData));
                await this.props.dispatch(tasksissuesActions.getAllByUserId(this.props.user.id));
                this.handleClose();
            } catch (e) {
                console.error("Problem", e)
            }
        }

        insertData();
    }

    handleReadOnlyTable = (DetailData) => {
        this.setState({
            taskId: DetailData.id,
            openReadOnly: true
        })
    }

    handleReadOnlyClose = () => {
        this.setState({
            openReadOnly: false
        })
    }

    render() {
        const { user } = this.props;

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />
                <ImportCSV open={this.state.importCsvOpen} data={this.state.importCsvData} handleCsvSaveClick={this.handleCsvSaveClick} close={this.handleClose} />

                <EnhancedTable
                    handleCreateTimesheetClick={this.handleCreateTimesheetClick}
                    handleEditTable={this.handleEditTable}
                    handleDeleteTable={this.handleDeleteTable}
                    handleCsvUpload={this.handleCsvUpload}
                    handleOpen={this.handleOpen}
                    handleReadOnlyTable={this.handleReadOnlyTable}
                    OwnerUserId={user.id}
                    Pagename='TasksIssues'
                />

                <TasksIssuesFormComponent
                    open={this.state.open}
                    close={this.handleClose}
                    TaskId={this.state.taskId}
                />

                <TasksIssuesReadOnlyFormComponent
                    open={this.state.openReadOnly}
                    close={this.handleReadOnlyClose}
                    TaskId={this.state.taskId}
                />
                {
                    user.departmentLocate === 'TW' ?
                        <TimesheetFormComponentTW
                            open={this.state.openTimesheetForm}
                            close={this.handleClose}
                            TaskId={this.state.taskId}
                        /> :
                        <TimesheetFormComponent
                            open={this.state.openTimesheetForm}
                            close={this.handleClose}
                            TaskId={this.state.taskId}
                        />
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, projects, tasksissues } = state;

    return {
        user,
        users,
        projects,
        tasksissues
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(App);


// WEBPACK FOOTER //
// ./src/components/TasksIssues/App.js